<template>
  <div id="sets--language">
    <v-toolbar color="transparent" dense flat>
      <v-toolbar-title>{{$t('settings_language')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>

    <v-list subheader class="pa-3">
      <template v-for="(item, index) in filteredItems">
        <v-list-tile
          :key="item.name + index"
          @click="clicked(item)"
          :class="item.lang === selectedLanguage ? 'selection' : ''"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{item.name}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider :key="index" />
      </template>
    </v-list>
  </div> 
</template>

<style>
</style>

<script>
  export default {
    data () {
      return {
        items: [
          {name: "Arabic - العربية", lang: "ar"},
          {name: "Bosnian - bosanski", lang: "bs"},
          {name: "German - Deutsch", lang: "de"},
          {name: "English", lang: "en"},
          {name: "Spanish - Español", lang: "es"},
          {name: "French - français", lang: "fr"},
          {name: "Hindi - हिन्दी, हिंदी", lang: "hi"},
          {name: "Croatian - hrvatski", lang: "hr"},
          {name: "Italian - Italiano", lang: "it"},
          {name: "Japanese - 日本語 (にほんご)", lang: "ja"},
          {name: "Portuguese - 	Português", lang: "pt"},
          {name: "Russian - русский", lang: "ru"},
          {name: "Turkish - Türkçe", lang: "tr"},
          {name: "Ukrainian - Українська", lang: "uk"},
          {name: "Chinese Simplified - 汉语", lang: "zh-CN"},
          {name: "Chinese Traditional - 漢語", lang: "zh-TW"}
        ],
      }
    },
    computed: {
      nextDisabled() {
        return 1
      },
      filteredItems() {
        console.log("filteredItems")
        if (this.langFilter !== '') {
          const filter = new RegExp(this.langFilter, 'i')
          return this.items.filter(it => it.name.match(filter))
        }
        return this.items
      },
      selectedLanguage() {
        let lang = this.$store.getters.getLanguage || window.navigator.userLanguage || window.navigator.language
        let loc = lang.split('-')
        return (loc.length > 1) ? loc[0] : lang
      }
    },
    methods: {
      clicked(item) {
        console.log("Language selected:" + item.lang)
        this.$store.dispatch('setLanguage', item.lang).then(()=>{
          this.$router.push({name:"LanguageLoader"})
        })
      },
      clearSearchFilter() {
        this.$nextTick(() => {
          this.langFilter = ''
        })
      }
    }
  }
</script>

